import * as React from "react";
const SvgFiRrBaseballAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-baseball-alt_svg__a)">
      <path
        fill="#062147"
        d="M22.712 7.5A4.4 4.4 0 0 0 19.6 0a4.36 4.36 0 0 0-3.1 1.288l-2.68 2.676a34 34 0 0 0-4.868 6.146 22 22 0 0 1-2.647 3.44l-4.17 4.171-.428-.428a1 1 0 1 0-1.414 1.414l5 5a1 1 0 1 0 1.414-1.414l-.39-.393 4.095-4.093c1.143-1.051 2.377-2 3.688-2.832a33.7 33.7 0 0 0 5.793-4.65zM4.9 20.49l-1.351-1.355 4.17-4.171c.16-.161.343-.357.54-.58l1.4 1.4c-.266.229-.493.437-.664.608zm8.124-7.2c-.591.374-1.212.81-1.794 1.246l-1.71-1.717c.396-.531.788-1.1 1.134-1.658a32 32 0 0 1 4.58-5.783L17.91 2.7a2.45 2.45 0 0 1 3.387 0 2.395 2.395 0 0 1 0 3.387l-2.821 2.824a31.7 31.7 0 0 1-5.45 4.374zm7.476 3.689a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-baseball-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBaseballAlt;
